import { render, staticRenderFns } from "./MeasurementsListActual.vue?vue&type=template&id=83b90e86&scoped=true&"
import script from "./MeasurementsListActual.vue?vue&type=script&lang=js&"
export * from "./MeasurementsListActual.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsListActual.vue?vue&type=style&index=0&id=83b90e86&prod&scoped=true&lang=css&"
import style1 from "./MeasurementsListActual.vue?vue&type=style&index=1&id=83b90e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b90e86",
  null
  
)

export default component.exports